<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="8">
        <v-text-field
          v-model="entry.name"
          v-bind="getObject('name')"
          label="Nome"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="4">
        <v-switch 
          v-model="entry.enabled" 
          inset 
          :label="entry.enabled ? 'Ativo' : 'Inativo'"
          :disabled="readOnly"
        >
        </v-switch>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <DateField
          :inputData.sync="entry.expirationDate"
          v-bind="getObject('expirationDate')"
          label="Data de Expiração"
          :hasTodayButton="true"
          autocomplete="off"
          clearable
          :disabled="readOnly"
          @click:clear="$nextTick(() => entry.expirationDate = null)"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-switch 
          v-model="entry.enabledNfce" 
          inset 
          :label="entry.enabledNfce ? 'Emissão de NFC-e Ativa' : 'Emissão de NFC-e Inativa'"
          :disabled="readOnly"
        >
        </v-switch>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-switch 
          v-model="entry.enabledMdfe" 
          inset 
          :label="entry.enabledMdfe ? 'Emissão de MDF-e Ativa' : 'Emissão de MDF-e Inativa'"
          :disabled="readOnly"
        >
        </v-switch>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-switch 
          v-model="entry.enabledNfse" 
          inset 
          :label="entry.enabledNfse ? 'Emissão de NFS-e Ativa' : 'Emissão de NFS-e Inativa'"
          :disabled="readOnly"
        >
        </v-switch>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-switch 
          v-model="entry.enabledLots" 
          inset 
          :label="entry.enabledLots ? 'Usa lotes' : 'Não usa lotes'"
          :disabled="readOnly"
        >
        </v-switch>
      </v-col>

      <v-col cols="12">
        <!-- multiselect criado por nós, que representa aquele componente que utiliza 2 colunas para passar de um lado para outro. -->
        <MultiSelect
          v-model="entry.businessActivityIds"
          v-bind="getObject('businessActivityIds')"
          label="Ramos de Atividades"
          :items="extraData.globalContext.allBusinessActivities"
          :readOnly="readOnly"
        />
      </v-col> 

      <v-col cols="12" sm="6" md="4">
        <MaskedTextField
          v-bind="getObject('groundsLimit')"
          :inputData.sync="entry.groundsLimit"
          mask-type="integer"
          label="Nº Máximo de Fazendas"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <MaskedTextField
          v-bind="getObject('stocksLimit')"
          :inputData.sync="entry.stocksLimit"
          mask-type="integer"
          label="Nº Máximo de Estoques"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <MaskedTextField
          v-bind="getObject('usersLimit')"
          :inputData.sync="entry.usersLimit"
          mask-type="integer"
          label="Nº Máximo de Usuários"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>


    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import MultiSelect from "@shared_components/multi_select.vue";
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    MultiSelect: MultiSelect,
    BaseUtil: BaseUtil
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
